import { reactive } from "@vue/reactivity"

import { getProductFamily } from "@/api";
import { UtilityService } from '@/utils';
import { ApiSkillPathMediaMenuEnum } from "@/enums/api/index";

const states = reactive({
    productOptions: [],
    levelGroup: [
        "lEVEL_FOUNDATIONALl",
        "lEVEL_MEDIUM",
        "lEVEL_ADVANCED",
    ],
    typeOptions: [
        {
            value: ApiSkillPathMediaMenuEnum.TUTORIAL,
            labelKey: 'COMMON.TUTOTIAL'
        }, 
        {
            value: ApiSkillPathMediaMenuEnum.MASTER_CLASS,
            labelKey: 'PAGE_MASTER_CLASS.MASTER_CLASS'
        }
    ]
})

const getters = {
    getProductVersion: (filterProduct) => {
        let productVersion = [];
        states.productOptions.forEach(option => {
            if (option.product == filterProduct) {
                option.versions.forEach(version => {
                    if (version != "") {
                        productVersion.push({
                            label: option.product + " " + version,
                            version
                        });
                    }
                });
            }
        });
        return productVersion;
    }
}

const actions = {
    fetchProductOptions: async() => {
        if (states.productOptions.length !== 0) {
            return;
        }
        try {
            const res = await getProductFamily();
            UtilityService.sortProduct(res, 'product');
            states.productOptions = UtilityService.getShowVersion(res);
        } 
        catch (err) {
            states.productOptions = null;
        }
    }
}

export default {
    states,
    getters,
    actions
}